import { ThirdParty } from '@generated/ThirdParty/PearCommerceProduct.model';
import { PearCommerceProduct, PearCommerceProductVariant } from './PearCommerceProduct';

type PearCommerceProductSitecoreProps =
  ThirdParty.PearCommerceProduct.RenderingParameters.PearCommerceProductParameters_Component;

const normalizeVariantName = (value?: string) =>
  (value || '')
    .trim()
    .toLowerCase()
    .replace(/[-_\s]/g, '');

const resolveVariant = (fieldNames?: string): PearCommerceProductVariant => {
  const normalized = normalizeVariantName(fieldNames);

  if (normalized.includes('productlocator')) {
    return 'Product-Locator';
  }

  return 'Retailer-List';
};

function PearCommerceProductDynamic(props: PearCommerceProductSitecoreProps) {
  const variant = resolveVariant(props.params?.FieldNames);
  return <PearCommerceProduct variant={variant} />;
}

// Camel-case aliases (used internally / for code references)
export const Default = PearCommerceProductDynamic;
export const RetailerList = PearCommerceProductDynamic;
export const ProductLocator = PearCommerceProductDynamic;

export default PearCommerceProductDynamic;
